import Cookies from 'universal-cookie/es6';
import { useHistory } from "react-router-dom";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : MenuItems
Description : Componente que contiene la información de los botones de la barra de navegación de la aplicación
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se defienen los botones de la barra de navegación.
================================================================================ */

export default function MenuItems3() {
    let history = useHistory();
    const items = [
        {
            label: 'Centro de costo',
            path: "/AccountantCost_center",
            index: 0,
        },
        {
            label: 'Plan de cuentas contables',
            path: "/AccountantAccount_Plan",
            index: 1,
        },
        {
            label: 'Terceros',
            path: "/AccountantThird",
            index: 2,
        },
        {
            label: 'Configuración',
            path: "/AccountantAccountingConf",
            index: 3,
        }
    ]
    return items
}